import type {AnyObject} from 'src/typings';
import type {ActionReturn} from 'svelte/action';

interface Parameters {
    disabled: boolean;
    duration: number;
}

const defaultParams: Parameters = {
    disabled: false,
    duration: 250
};

export function heightResizeAnimation(node: HTMLElement, params: Parameters = defaultParams): ActionReturn<Parameters, AnyObject> {
    function updateHeight() {
        if (!params.disabled) {
            const childrenHeight = [...node.children].reduce((acc, item) => acc + (item instanceof HTMLElement ? item.offsetHeight : 0), 0);
            node.style.setProperty('height', `${childrenHeight}px`);
        }
    }

    const observer = new MutationObserver(() => {
        updateHeight();
    });
    observer.observe(node, {characterData: true, subtree: true, childList: true});

    updateHeight();

    node.style.setProperty('overflow', 'hidden');
    node.style.setProperty('transition', `height ${params.duration}ms ease`);

    return {
        update(updatedParams: Parameters) {
            node.style.setProperty('transition', `height ${updatedParams.duration}ms ease`);
        },
        destroy() {
            observer?.disconnect();
        }
    };
}